export const COLOR = '#059669';
export const LIGHT_COLOR = '#ECFDF5';
export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/prohandy-on-demand-home-service-marketplace`;
export const DEMO_URL = 'https://prohandy.xgenious.com/';
export const CODECANYON_URL = 'https://codecanyon.net/item/prohandy-on-demand-home-service-marketplace-platform/55091770';
export const REGULAR_PRICE = 39;
export const COMBO_PRICE = 69;
export const EXTENDED_PRICE = 149;

export const REVIEWS = [
  {
    name: 'homefix_dev',
    rating: 5,
    category: 'Regular License',
    body: 'Excellent marketplace platform. The cart system for booking multiple services in one transaction is exactly what we needed. Installation was smooth and support was responsive.',
  },
  {
    name: 'service_market',
    rating: 5,
    category: 'Regular License',
    body: 'Live chat between clients and providers works seamlessly. Google Maps integration for job listings is spot on. Clean code and a great product overall.',
  },
  {
    name: 'digitalbiz_pro',
    rating: 5,
    category: 'Extended License',
    body: 'The job posting and hiring workflow is outstanding. The provider offers system is a unique feature that sets this apart from other marketplace scripts. Highly recommended.',
  },
];
